import { useEffect, useMemo, useState } from "react";
import MobileHeader from "../component/MobileHeader";
import "../css/mobilesignup.css"
import { useNavigate } from "react-router-dom";
import axios from "axios";

export default function MobileSignUp() {
    const navigate = useNavigate();
    const [id, setId] = useState("");
    const [idChecking, setIdChecking] = useState(false);
    const [idCheckedOk, setIdCheckedOk] = useState(false);
    const [idCheckResult, setIdCheckResult] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);


    const [fieldData, setFieldData] = useState([]);
    const [companyData, setCompanyData] = useState([]);

    const fmt = (s) => {
        const m = Math.floor(Math.max(0, s) / 60);
        const sec = Math.max(0, s) % 60;
        return `${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;
    };

    const [signupData, setSignupData] = useState({
        fldIdx: "",
        aboveIdx: "",
        userName: "",
        position: "관리자",
        id: "",
        passwd: "",
        passwd2: "",
        phoneNumber: ""
    })

    // 🔹 현장 리스트 가져오기
    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_BASE_URL}/fieldList`)
            .then((resp) => {
                setFieldData(resp.data);
            })
            .catch((err) => {
                console.error("fieldList 조회 실패:", err);
            });
    }, []);  // ✅ 최초 1번만 호출되도록 빈 배열

    useEffect(() => {
        // 현장을 아직 선택 안 했으면 업체 초기화
        if (!signupData.fldIdx) {
            setCompanyData([]);
            setSignupData((prev) => ({
                ...prev,
                aboveIdx: "", // 현장 바뀌면 업체 선택도 초기화
            }));
            return;
        }

        axios
            .get(`${process.env.REACT_APP_API_BASE_URL}/aboveListByField`, {
                params: { fldIdx: signupData.fldIdx }, // ⬅ @RequestParam int fieldUid 에 매핑
            })
            .then((resp) => {
                const data = Array.isArray(resp.data) ? resp.data : (resp.data?.list ?? []);
                setCompanyData(data);
                setSignupData((prev) => ({ ...prev, aboveIdx: "" }));
            })
            .catch((err) => {
                console.error("companyList 조회 실패:", err);
                setCompanyData([]);
                setSignupData((prev) => ({
                    ...prev,
                    aboveIdx: "",
                }));
            });
    }, [signupData.fldIdx]);

    const isValidId = useMemo(
        () => !!(signupData.id || "").trim(), // 단순히 "입력 여부"만 확인
        [signupData.id]
    );

    const isValidPw = !!(signupData.passwd || "").trim(); // 그냥 입력 여부만 확인
    const isPwMatch = !!signupData.passwd && signupData.passwd === signupData.passwd2;

    // 전화번호 (숫자만 10~11자리 정도로 간단 체크)
    const digits = (signupData.phoneNumber || "").replace(/\D/g, "");
    const isValidPhone = /^\d{10,11}$/.test(digits);

    // 필수 텍스트들
    const hasName = !!(signupData.userName || "").trim();
    const hasPosition = !!(signupData.position || "").trim();
    const hasField = !!signupData.fldIdx;
    const hasCompany = !!signupData.aboveIdx;


    const canSubmit =
        isValidId &&
        idCheckedOk &&
        isValidPw &&
        isPwMatch &&
        hasName &&
        hasPosition &&
        hasField &&
        hasCompany &&
        isValidPhone &&
        !idChecking &&
        !isSubmitting;

    const handlerInputChange = (e) => {
        const { name, value } = e.target;
        setSignupData((prev) => ({
            ...prev,
            [name]: value,
        }));
        if (name === "id") {
            setIdCheckedOk(false); // 아이디 변경 시 중복확인 다시
            setIdCheckResult(null);
        }
    };

    const handleIdCheck = () => {
        if (!isValidId) {
            alert("아이디를 입력하세요.");
            return;
        }

        setIdChecking(true);

        axios
            .get(`${process.env.REACT_APP_API_BASE_URL}/check-id`, {
                params: { id: (signupData.id || "").toLowerCase() },
            })
            .then(({ data }) => {
                const ok = data && data.available === true;
                setIdCheckResult(ok);
                setIdCheckedOk(ok);
            })
            .catch((err) => {
                console.error(err);
                alert("중복확인 중 오류가 발생했습니다.");
                setIdCheckResult(null);
                setIdCheckedOk(false);
            })
            .finally(() => {
                setIdChecking(false);
            });
    };
    // ====== 휴대폰 번호 E.164(+82) 보정 ======
    const toE164KR = (raw) => {
        const only = (raw || "").replace(/\D/g, "");
        // 국내 010XXXXXXXX 형태 가정
        // 0으로 시작하면 국가코드 +82로 치환
        if (only.startsWith("0")) {
            // 010-1234-5678 -> +82 10 1234 5678 -> +821012345678
            return "+82" + only.substring(1);
        }
        // 이미 국가코드가 붙었거나 기타 형식은 서버에서 추가 검증
        return only.startsWith("+") ? only : "+" + only;
    };


    // ====== 회원가입 제출 ======
    const handleSubmit = (e) => {
        e.preventDefault();
        if (!canSubmit || isSubmitting) return;

        setIsSubmitting(true);
        axios
            .post(`${process.env.REACT_APP_API_BASE_URL}/signup`, {
                ...signupData,
                id: (signupData.id || "").toLowerCase(),
                phoneNumber: toE164KR(signupData.phoneNumber),
            })
            .then(() => {
                alert("회원가입이 완료되었습니다");
                navigate("/");            // ✅ 성공했을 때만 이동
            })
            .catch((err) => {
                console.error(err);
                alert("이미 가입된 전화번호입니다"); // ✅ 실패면 팝업만 띄우고 이동 X
            })
            .finally(() => setIsSubmitting(false));
    };

    return (
        <>
            <form onSubmit={handleSubmit}>
                <nav className="Nav_Signup">
                    <MobileHeader onPrev={() => window.history.back()}></MobileHeader>
                    <div>
                        <p>아이디</p>
                        <div>
                            <input type="text" name="id" value={signupData.id} onChange={handlerInputChange}></input>
                            <button type="button"
                                onClick={handleIdCheck}
                                // 조건 충족 전: 기존 스타일 그대로, 클릭도 막기
                                disabled={!isValidId || idChecking}
                                // 조건 충족 시: 파란색 활성 (CSS에서 .is-active 스타일 적용)
                                className={`btn-check ${isValidId && !idChecking ? "is-active" : ""}`}
                                aria-disabled={!isValidId || idChecking}>중복확인</button>
                        </div>
                        {idCheckResult === true && (
                            <p style={{ color: "green" }}>✅ 사용 가능한 아이디입니다.</p>
                        )}
                        {idCheckResult === false && (
                            <p style={{ color: "red" }}>❌ 이미 사용중인 아이디입니다.</p>
                        )}
                    </div>
                    <div>
                        <p>비밀번호</p>
                        <input type="password"
                            name="passwd"
                            value={signupData.passwd}
                            onChange={handlerInputChange}
                            autoComplete="new-password"></input>
                        <input type="password"
                            name="passwd2"
                            value={signupData.passwd2}
                            onChange={handlerInputChange}
                            placeholder="비밀번호 확인"
                            autoComplete="new-password"></input>
                        {!isPwMatch && signupData.passwd2 && (
                            <small className="error">비밀번호가 일치하지 않습니다.</small>
                        )}
                    </div>
                    <div>
                        <p>현장명</p>
                        <select
                            name="fldIdx"
                            value={signupData.fldIdx}
                            onChange={handlerInputChange}
                        >
                            <option value="">현장을 선택해주세요</option>
                            {fieldData.map((field) => (
                                <option key={field.fldIdx} value={field.fldIdx}>
                                    {field.fldNM}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <p>원도급사명</p>
                        <select
                            name="aboveIdx"
                            value={signupData.aboveIdx}
                            onChange={handlerInputChange}
                            disabled={!signupData.fldIdx || companyData.length === 0} // 🔹 현장 선택 전에는 비활성화
                        >
                            <option value="">
                                {signupData.fldIdx
                                    ? "업체를 선택해주세요"
                                    : "현장을 먼저 선택해주세요"}
                            </option>

                            {companyData.map((company) => (
                                <option key={company.aboveIdx} value={company.aboveIdx}>
                                    {company.aboveNM}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <p>직무</p>
                        <input type="text"
                            name="position"
                            value={signupData.position}
                            onChange={handlerInputChange}
                        ></input>
                    </div>
                    <div>
                        <p>성명</p>
                        <input
                            type="text"
                            name="userName"
                            value={signupData.userName}
                            onChange={handlerInputChange}
                            placeholder="이름을 입력해 주세요"></input>
                    </div>
                    <div>
                        <p>전화번호</p>
                        <div>
                            <input
                                type="text"
                                name="phoneNumber"
                                value={signupData.phoneNumber}
                                onChange={handlerInputChange}
                                placeholder="숫자만 입력해주세요"></input>

                        </div>
                    </div>
                    <div>
                        <button type="submit"
                            disabled={!canSubmit}
                            className={`btn-submit ${canSubmit ? "is-active" : ""}`}>회원가입</button>
                    </div>

                </nav>
            </form>
        </>
    )
}